import { Component, Fragment, RefObject, createRef } from "react";
import "./ProvidersPage.scss";
import { Company } from "../../core/models/company.model";
import { Category } from "../../core/models/category.model";
import LinkButton from "../../components/buttons/LinkButton/LinkButton";
import { IconArrowUp } from "../../assets/svgs-index";
import { WelcomePageLabels } from "../../assets/labels/labels";
import SelectList from "../../components/SelectList/SelectList";
import { Option } from "../../core/models/components.model";
import CompanyCard from "../../components/CompanyCard/CompanyCard";
import ModalRegister from "../../components/Modals/ModalRegister";
import { CompanyService } from "../../core/services/company.service";
import { CategoryService } from "../../core/services/category.service";
import Spinner from "../../components/spinner/Spinner";

interface ProvidersPageProps {
  selectedCategory?: Category;
  isDisabled?: Boolean;
  selectedOptions: Option[];
  suggestions: Option[];
  companies: Company[];
  isLoading: boolean;
  onGoBack: () => void;
  onGoActive: () => void;
  onUnselectCategory: () => void;
}

interface ProvidersPageState {
  selectedCategories: string[];
  selectedOptions: Option[];
  suggestions: Option[];
  companies: Company[];
  selectedCompany: Company | undefined;
  modalIsOpen: boolean;
  isDisabled: boolean;
  isLoading: boolean;
}

class ProvidersPage extends Component<ProvidersPageProps, ProvidersPageState> {
  selectListRef: RefObject<SelectList>;

  constructor(props: ProvidersPageProps) {
    super(props);
    this.selectListRef = createRef<SelectList>();

    this.state = {
      selectedCategories: [],
      selectedOptions: props.selectedOptions,
      suggestions: props.suggestions,
      companies: props.companies,
      selectedCompany: undefined,
      modalIsOpen: false,
      isDisabled: !!props.isDisabled,
      isLoading: props.isLoading,
    };
  }

  componentDidUpdate(prevProps: Readonly<ProvidersPageProps>): void {
    if (prevProps?.companies !== this.props.companies) {
      this.setState({ companies: this.props.companies, isLoading: false }, () =>
        this.handleOptChanged(this.state.selectedOptions)
      );
    }
    if (prevProps?.isDisabled !== this.props.isDisabled) {
      this.setState({ isDisabled: !!this.props.isDisabled });
      if (!this.props.isDisabled) {

      }
    }
    if (prevProps?.selectedOptions !== this.props.selectedOptions) {
      this.setState({
        selectedOptions: this.props.selectedOptions,
      });
    }
    if (prevProps?.suggestions !== this.props.suggestions) {
      this.setState({
        suggestions: this.props.suggestions,
      });
    }
    if (
      prevProps.selectedCategory !== this.props.selectedCategory &&
      !this.props.selectedCategory
    ) {
      this.setState({
        companies: CompanyService.filterCompanies(
          this.props.companies,
          this.props.selectedOptions
        ),
      });
    }

    if (prevProps?.isLoading !== this.props.isLoading) {
      this.setState({
        isLoading: this.props.isLoading,
      });
    }
  }

  handleOptChanged = (options: Option[]) => {
    const { companies, selectedCategory } = this.props;

    if (selectedCategory &&
      !CategoryService.findCategoryInOptions(options, selectedCategory)
    ) {
      this.props.onUnselectCategory();
      this.setState({ selectedOptions: options });
    } else if (
      !options?.length ||
      (options?.length === 1 &&
        CategoryService.findCategoryInOptions(options, selectedCategory))
    ) {
      this.setState({ companies, selectedOptions: options });
    } else {
      const filteredCompanies = CompanyService.filterCompanies(
        companies,
        options
      );
      this.setState({ companies: filteredCompanies, selectedOptions: options });
    }
  };

  handleAddCompany = (selectedCompany: Company) => {
    this.setState({ selectedCompany, modalIsOpen: true });
  };

  renderModal = () => {
    const { modalIsOpen, selectedCompany } = this.state;
    if (!modalIsOpen || !selectedCompany) {
      return <Fragment />;
    }
    return (
      <ModalRegister
        modalIsOpen={modalIsOpen}
        company={selectedCompany}
        onClose={() => this.setState({ modalIsOpen: false })}
      />
    );
  };

  handleGoBack = () => {
    this.handleOptChanged([]);
    this.props.onGoBack();
  }

  render() {
    const { companies, selectedOptions, suggestions, isDisabled, isLoading } = this.state;

    const renderCompanyList = () => {
      if (isLoading) {
        return <Fragment />;
      }
      return companies?.map((c, index) => {
        return (
          <CompanyCard
            company={c}
            key={index}
            onClick={this.handleAddCompany}
          />
        );
      });
    };

    const renderBackButton = () => {
      return (
        <LinkButton
          onClick={this.handleGoBack}
          styleClass="w-100 d-flex justify-content-center link-container"
          valueText={WelcomePageLabels.providersPage.goBackButton}
          icon={IconArrowUp}
        />
      );
    };

    const renderLoading = () => {
      if (!this.state.isLoading) {
        return <Fragment />;
      }
  
      return <Spinner styleClass={'mt-4'} message="A filtrar prestadores de serviços..."/>;
    };

    return (
      <Fragment>
        <div className="main-page-container" id="providers-main-page">
          <div className="w-100 top-section-container d-flex flex-column px-3">
            <div className="back-button-container">{renderBackButton()}</div>

            <div
              className="search-bar-container"
              onClick={this.props.onGoActive}
              role="button"
            >
              <SelectList
                ref={this.selectListRef}
                selectedOptions={selectedOptions}
                onChange={this.handleOptChanged}
                options={suggestions}
                config={{
                  isMulti: true,
                  isClearable: true,
                  autoFocus: true,
                  isDisabled: !!isDisabled,
                }}
                placeholder={"Pesquise um Prestador de Serviços..."}
              />
            </div>
          </div>
          <div
            className="company-container grid-scroll-container mt-4 px-3"
            id="company-scroll-container"
          >
            {renderLoading()}
            <div
              className="company-list-container grid-container"
              id="company-list-container"
            >
              {renderCompanyList()}
            </div>
          </div>
          <div className="scroll-base-container"></div>
        </div>
        {this.renderModal()}
      </Fragment>
    );
  }
}

export default ProvidersPage;
